import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const TutorShiftSetApiUtils = {
  fetchByTutor(tutorId) {
    return xhr(
      ApiConstants.Base + 'tutors/' + tutorId + '/settings/shift_sets',
    );
  },

  create(tutorId, params = {}) {
    return xhr(
      ApiConstants.Base + 'tutors/' + tutorId + '/settings/shift_sets',
      {
        method: 'post',
        body: JSON.stringify({
          shift_set_params: params,
        }),
      },
    );
  },

  setEndDate(tutorId, shiftSetId, date) {
    return xhr(
      ApiConstants.Base +
        'tutors/' +
        tutorId +
        '/settings/shift_sets/' +
        shiftSetId,
      {
        method: 'put',
        body: JSON.stringify({
          date,
        }),
      },
    );
  },
};

export default TutorShiftSetApiUtils;
